import React from 'react';

import { RatingStarIcon } from '@/widgets/StarRating';

import { calculateSatisfaction } from '@/utilities/calculateSatisfaction';

import { SellerRatingChipsProps } from './models';

import { Message } from 'iconsax-react';

export const SellerRatingChips = ({ storeRating, storeReviewCount, showReviewCount = false, size = 'md' }: SellerRatingChipsProps) => {
    const satisfaction = calculateSatisfaction(storeRating as number, storeReviewCount as number);
    const hasStoreRating = typeof storeRating === 'number' && !Number.isNaN(storeRating);
    const iconClassName = size === 'sm' ? 'size-3' : 'size-3.5';

    return (
        <>
            <span className={`flex items-center gap-1 rounded-full px-2 py-0.5 text-[11px] sm:text-xs ${satisfaction.className}`}>
                عملکرد {satisfaction?.performance}
            </span>
            {hasStoreRating ? (
                <>
                    <span className={`flex items-center gap-1 rounded-full px-2 py-0.5 text-[11px] sm:text-xs ${satisfaction.className}`}>
                        <RatingStarIcon size='sm' className={iconClassName} />
                        {storeRating}
                    </span>
                    {showReviewCount && (
                        <span className='flex items-center gap-1 rounded-full bg-gray-100 px-2 py-0.5 text-[11px] text-gray-600 sm:text-xs'>
                            <Message color='currentcolor' className={iconClassName} />
                            {storeReviewCount || 0} نظر
                        </span>
                    )}
                </>
            ) : (
                <span className='flex items-center gap-1 rounded-full bg-gray-50 px-2 py-0.5 text-[11px] text-gray-500 sm:text-xs'>
                    <Message color='currentcolor' className={iconClassName} />
                    بدون نظر
                </span>
            )}
        </>
    );
};
